import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
// import { ConsoleReporter } from "jasmine";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { MasterService } from "src/app/services/master.service";



@Component({
  selector: 'app-secure-lottery-au',
  templateUrl: './lottery-au.component.html',
  styleUrls: ['./lottery-au.component.scss'],
})
export class LotteryAuComponent implements OnInit {

  lotteryKey: number;
  pageMode: string;
  lotteryResponseModel : LotteryResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  boardsList: {[key:number]:string};
  stageList: string[];
  paymentGatewayList: string[];
  isLoading = false;

  showDraftList: boolean = false;
  showFinalList: boolean = false;
  showLoiBtn: boolean = false;
  showGenerateDrawResultBtn: boolean = false;
  showPolBtn: boolean = false;
  type: string;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // private boardService: MasterService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {} 

  ngOnInit() {

    console.log("Lottery component on init called");
    this.route.params.subscribe((params: Params) => {
      this.lotteryKey = +params["key"];
      this.type = params["type"];
     
      this.masterService
        .initLotteryForm(this.lotteryKey)
        .subscribe((data: any) => {
          this.isLoading = true;
          if(data.status === 'SUCCESS') {
            this.boardsList = data.boards;
            this.stageList = data.stages;
            this.paymentGatewayList = data.paymentGateways;
            console.log(this.paymentGatewayList);
            this.isLoading = false;
            if(this.lotteryKey) {
              console.log("Lottery key get for edit " + this.lotteryKey);
              this.masterService
              .getLotteryBykey(this.lotteryKey)
              .subscribe((data: any) => {
                this.lotteryResponseModel = data;
                this.pageMode = "Edit";
                console.log('form mode Edit ******',data);

                this.showDraftList = this.lotteryResponseModel.lotteryStage == 'PRE_LOTTERY_SCRUTINY' ? true : false;
                this.showFinalList = this.lotteryResponseModel.lotteryStage == 'PRE_LOTTERY_SCRUTINY' && this.lotteryResponseModel.draftPublishApplication == "Y" ? true : false;
                this.showLoiBtn = this.lotteryResponseModel.lotteryStage == 'POST_LOTTERY' && this.lotteryResponseModel.finalPublishApplication == "Y" ? true : false;
                this.showGenerateDrawResultBtn = this.lotteryResponseModel.lotteryStage == 'POST_LOTTERY' ? true : false;
                this.showPolBtn = this.lotteryResponseModel.lotteryStage == 'POST_LOTTERY' ? true : false;

                //TODO set board as key value pair
                this.form.setValue({
                  lotteryCode: this.lotteryResponseModel.lotteryCode,
                  lotteryName: this.lotteryResponseModel.lotteryName,
                  applicationFee: this.lotteryResponseModel.applicationFee,
                  emdAmount: this.lotteryResponseModel.emdAmount,
                  lotteryStage: this.lotteryResponseModel.lotteryStage,
                  draftPublishApplication: this.lotteryResponseModel.draftPublishApplication == "Y" ? true : false,
                  // draftPublishApplication: this.lotteryResponseModel.draftPublishApplication,
                  finalPublishApplication: this.lotteryResponseModel.finalPublishApplication== "Y" ? true : false,
                  // finalPublishApplication: this.lotteryResponseModel.finalPublishApplication,
                  publishResult: this.lotteryResponseModel.publishResult == "Y" ? true : false,
                  publishIntimationLetter: this.lotteryResponseModel.publishIntimationLetter == "Y" ? true : false,
                  // publishResult : this.lotteryResponseModel.publishResult,
                  displaySequence: this.lotteryResponseModel.displaySequence,
                  applicationStartDate: this.lotteryResponseModel.applicationStartDate,
                  applicationEndDate: this.lotteryResponseModel.applicationEndDate,
                  onlinePaymentStartDate: this.lotteryResponseModel.onlinePaymentStartDate,
                  onlinePaymentEndDate: this.lotteryResponseModel.onlinePaymentEndDate,
                  rtgsNeftEndDate: this.lotteryResponseModel.rtgsNeftEndDate,
                  onlinePaymentEndDateUpdate: this.lotteryResponseModel.onlinePaymentEndDateUpdate,
                  draftPublishApplicationDate: this.lotteryResponseModel.draftPublishApplicationDate,
                  finalPublishApplicationDate: this.lotteryResponseModel.finalPublishApplicationDate,
                  lotteryRunDate: this.lotteryResponseModel.lotteryRunDate,
                  refundStartDate: this.lotteryResponseModel.refundStartDate,
                  paymentGateway: this.lotteryResponseModel.paymentGateway.split("#"),
                  bankVerification: this.lotteryResponseModel.bankVerification,
                  publishPOLLetter: this.lotteryResponseModel.publishPOLLetter == "Y" ? true : false,
                  boardKey:{key: this.lotteryResponseModel.boardKey, value: this.lotteryResponseModel.boardCodeName}
                });
              });
            }
            else {
              this.pageMode = "Add";
              console.log('form mode add');
            }
          }
          else {
            //toast data.errorMessage
          }
        });
        
     
      this.form = new FormGroup({
        lotteryCode: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required),
        lotteryName: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required),
        applicationFee: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required),
        emdAmount: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required),
        lotteryStage: new FormControl(null, Validators.required),
        draftPublishApplication: new FormControl(null),
        finalPublishApplication: new FormControl(null),
        publishResult: new FormControl(null),
        publishIntimationLetter: new FormControl(null),
        displaySequence: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required),
        applicationStartDate: new FormControl(null, Validators.required),
        applicationEndDate: new FormControl(null, Validators.required),
        onlinePaymentStartDate: new FormControl(null, Validators.required),
        onlinePaymentEndDate: new FormControl(null, Validators.required),
        rtgsNeftEndDate: new FormControl(null, Validators.required),
        onlinePaymentEndDateUpdate: new FormControl(null, Validators.required),
        draftPublishApplicationDate: new FormControl(null, Validators.required),
        finalPublishApplicationDate: new FormControl(null, Validators.required),
        lotteryRunDate: new FormControl(null, Validators.required),
        refundStartDate: new FormControl(null, Validators.required),
        paymentGateway: new FormControl(null,Validators.required),
        bankVerification: new FormControl(null),
        publishPOLLetter: new FormControl(null),
        boardKey: new FormControl({value: null, disabled: this.lotteryKey > 0 ? true : false}, Validators.required)
      });
    });
  }

  // onFileSelect(event) {
  //   this.boardLogoFile = event.target.files[0];
  // }

  
  onCheckboxChangeDraftPublish(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }
  onCheckboxChangeFinalPublish(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }
  onCheckboxChangeResult(e: any) {
    if(e.target){
      console.log("check box ticked");
    }
  }



  onSubmit() {
    if(this.pageMode === 'Add') {
      console.log("going to save");
      this.saveLottery();
    }
    else {
      console.log("going to update");
      this.updateBoard();
    }
  }



  async saveLottery() {
    console.log("in save Lottery");
    // console.log(this.form.value.draftPublishApplicationDate);
    // if (this.form.valid) {
      console.log("in save Lottery form vaideated");
      console.log(this.form.value.bankVerification);
//      let text = this.form.value.paymentGateway.toString().replaceAll(",", "#");

      if(!this.validateApplicationStartDate()) {
        this.masterService.errorToast("Application Start Date should be greater than or equal Current Date");
        this.isSubmitDisabled = false;
        return;
      }

      if(!this.validateApplicationFee()){
        this.masterService.errorToast("Application Fee should be greater than 0");
        this.isSubmitDisabled = false;
        return;
      }

       if(!this.validateEMDAmount()){
        this.masterService.errorToast("EMD Amount should be greater than 0");
        this.isSubmitDisabled = false;
        return;
      }

      if(!this.validateDisplaySeq()){
        this.masterService.errorToast("Display Seq should be greater than 0");
        this.isSubmitDisabled = false;
        return;
      }

      if(!this.validateApplicationEndDate()) {
        this.masterService.errorToast("Application End Date should be greater than Application Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentStartDate()) {
        this.masterService.errorToast("Online Payment Start Date should be greater than Application Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentEndDate()) {
        this.masterService.errorToast("Online Payment End Date should be greater than or Equal Online Payment Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateRtgsNeftEndDate()) {
        this.masterService.errorToast("RTGS - NEFT Payment Date should be greater than Online Payment Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentEndDateUpdate()) {
        this.masterService.errorToast("Online Payment End Date Update should be greater than or Equal Online Payment End Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateDraftPublishApplicationDate()) {
        this.masterService.errorToast("Draft Publish Application Date should be greater than Online Payment End Date And Rtgs Payment Last date ");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateFinalPublishApplicationDate()) {
        this.masterService.errorToast("Final Publish Application Date should be greater than Draft Publish Application Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateLotteryRunDate()) {
        this.masterService.errorToast("Lottery Run Date should be greater than Final Publish Application Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateRefundStartDate()) {
        this.masterService.errorToast("Refund Start Date should be greater than Lottery Run Date");
        this.isSubmitDisabled = false;
        return;
      }
      
        this.masterService
        .saveLottery({
          lotteryCode: this.form.value.lotteryCode,
          lotteryName: this.form.value.lotteryName,
          activeFlag: this.form.value.activeFlag,
          applicationFee: this.form.value.applicationFee,
          emdAmount: this.form.value.emdAmount,
          lotteryStage:this.form.value.lotteryStage,
          draftPublishApplication:this.form.value.draftPublishApplication,
          finalPublishApplication:this.form.value.finalPublishApplication,
          publishResult:this.form.value.publishResult,
          publishIntimationLetter: this.form.value.publishIntimationLetter,
          displaySequence:this.form.value.displaySequence,
          boardKey: this.form.value.boardKey?.key,
          applicationStartDate:this.form.value.applicationStartDate,
          applicationEndDate:this.form.value.applicationEndDate,
          onlinePaymentStartDate:this.form.value.onlinePaymentStartDate,
          onlinePaymentEndDate:this.form.value.onlinePaymentEndDate,
          rtgsNeftEndDate:this.form.value.rtgsNeftEndDate,
          onlinePaymentEndDateUpdate:this.form.value.onlinePaymentEndDateUpdate,
          draftPublishApplicationDate:this.form.value.draftPublishApplicationDate,
          finalPublishApplicationDate:this.form.value.finalPublishApplicationDate,
          lotteryRunDate:this.form.value.lotteryRunDate,
          refundStartDate:this.form.value.refundStartDate,
          paymentGateway:this.form.value.paymentGateway.toString().replaceAll(",", "#"),
          bankVerification:this.form.value.bankVerification,
          publishPOLLetter: this.form.value.publishPOLLetter,
         
        }).subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "master", "lottery", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      // };
    } 
    


  async updateBoard() {
    console.log(this.form.value);
    console.log(this.form);
    
    if (this.form.valid) {

      if(!this.validateApplicationEndDate()) {
        this.masterService.errorToast("Application End Date should be greater than Application Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentStartDate()) {
        this.masterService.errorToast("Online Payment Start Date should be greater than Application Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentEndDate()) {
        this.masterService.errorToast("Online Payment End Date should be greater than or Equal Online Payment Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateRtgsNeftEndDate()) {
        this.masterService.errorToast("Rtgs Neft Payment Date should be greater than Online Payment Start Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateOnlinePaymentEndDateUpdate()) {
        this.masterService.errorToast("Online Payment End Date Update should be greater than or Equal Online Payment End Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateDraftPublishApplicationDate()) {
        this.masterService.errorToast("Draft Publish Application Date should be greater than Online Payment End Date And Rtgs Payment Last date ");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateFinalPublishApplicationDate()) {
        this.masterService.errorToast("Final Publish Application Date should be greater than Draft Publish Application Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateLotteryRunDate()) {
        this.masterService.errorToast("Lottery Run Date should be greater than Final Publish Application Date");
        this.isSubmitDisabled = false;
        return;
      }
  
      if(!this.validateRefundStartDate()) {
        this.masterService.errorToast("Refund Start Date should be greater than Lottery Run Date");
        this.isSubmitDisabled = false;
        return;
      }
      

      this.masterService
      .updateLottery(this.lotteryKey, {
        lotteryCode: this.lotteryResponseModel.lotteryCode,
        lotteryName: this.lotteryResponseModel.lotteryName,
        activeFlag: this.lotteryResponseModel.activeFlag,
        applicationFee: this.lotteryResponseModel.applicationFee,
        emdAmount: this.lotteryResponseModel.emdAmount,
        lotteryStage:this.form.value.lotteryStage,
        draftPublishApplication:this.form.value.draftPublishApplication,
        finalPublishApplication:this.form.value.finalPublishApplication,
        publishResult:this.form.value.publishResult,
        publishIntimationLetter: this.form.value.publishIntimationLetter,
        displaySequence:this.lotteryResponseModel.displaySequence,
        boardKey: this.lotteryResponseModel.boardKey,
        applicationStartDate:this.form.value.applicationStartDate,
        applicationEndDate:this.form.value.applicationEndDate,
        onlinePaymentStartDate:this.form.value.onlinePaymentStartDate,
        onlinePaymentEndDate:this.form.value.onlinePaymentEndDate,
        rtgsNeftEndDate:this.form.value.rtgsNeftEndDate,
        onlinePaymentEndDateUpdate:this.form.value.onlinePaymentEndDate,
        draftPublishApplicationDate:this.form.value.draftPublishApplicationDate,
        finalPublishApplicationDate:this.form.value.finalPublishApplicationDate,
        lotteryRunDate:this.form.value.lotteryRunDate,
        refundStartDate:this.form.value.refundStartDate,
        paymentGateway:this.form.value.paymentGateway.toString().replaceAll(",", "#"),
        bankVerification:this.form.value.bankVerification,
        publishPOLLetter: this.form.value.publishPOLLetter
      })
        .subscribe((data: any) => {
          this.isLoading = true;
            if(data.status === 'SUCCESS') {
              this.isLoading = false;
              this.successToast();
              this.router.navigate(["/secure", "master", "lottery", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
              this.isLoading = false;
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("Please enter valid data for all fields.");
    }
  }

  validateApplicationStartDate() {
    return new Date(this.form.value.applicationStartDate) >= new Date()
    ? true
    : false;
  }

  validateDisplaySeq() {
    return this.form.value.displaySequence > 0
    ? true
    : false;
  }

  validateApplicationFee() {
    return this.form.value.applicationFee > 0
    ? true
    : false;
  }

  validateEMDAmount(){
    return this.form.value.emdAmount > 0
    ? true
    : false;
  }

  validateApplicationEndDate() {
    return new Date(this.form.value.applicationStartDate) < new Date(this.form.value.applicationEndDate)
    ? true
    : false;
  }

  validateOnlinePaymentStartDate() {
    return new Date(this.form.value.applicationStartDate) <= new Date(this.form.value.onlinePaymentStartDate)
    ? true
    : false;
  }
  validateOnlinePaymentEndDate() {
    return new Date(this.form.value.onlinePaymentStartDate) < new Date(this.form.value.onlinePaymentEndDate)
    ? true
    : false;
  }

  validateOnlinePaymentEndDateUpdate() {
    return new Date(this.form.value.onlinePaymentEndDate) <= new Date(this.form.value.onlinePaymentEndDateUpdate)
    ? true
    : false;
  }

  validateRtgsNeftEndDate() {
    return new Date(this.form.value.onlinePaymentStartDate) < new Date(this.form.value.rtgsNeftEndDate)
    ? true
    : false;
  }

  validateDraftPublishApplicationDate() {
    return (new Date(this.form.value.onlinePaymentEndDateUpdate) < new Date(this.form.value.draftPublishApplicationDate)  
            && new Date(this.form.value.rtgsNeftEndDate)  < new Date(this.form.value.draftPublishApplicationDate))
    ? true
    : false;
  }

  validateFinalPublishApplicationDate() {
    return new Date(this.form.value.draftPublishApplicationDate) < new Date(this.form.value.finalPublishApplicationDate)
    ? true
    : false;
  }

  validateLotteryRunDate() {
    return new Date(this.form.value.finalPublishApplicationDate) < new Date(this.form.value.lotteryRunDate)
    ? true
    : false;
  }

  validateRefundStartDate() {
    return new Date(this.form.value.lotteryRunDate) < new Date(this.form.value.refundStartDate)
    ? true
    : false;
  }

  async successToast() {
    await this._snackBar.open(
      "Lottery details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showBoard(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  showStage(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  showPaymentGateway(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }
  

  genereteDraftList(lstName : string){
    console.log("Generete "+lstName+" List Call");
    console.log(this.lotteryResponseModel.boardKey);
    console.log(this.lotteryKey);

    this.isLoading = true;
    this.masterService.genereteDraftList(this.lotteryResponseModel.boardKey, this.lotteryKey)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = true;
      if(data.status === 'SUCCESS') {
        this.masterService.successToast(lstName+" List generated Successfully.");
        this.isLoading = false;
      }
      else {
        this.errorToast(data.errorMessage);
        this.isLoading = false;
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
   
  }

  generateHashcodeReport() {
    this.isLoading = true;
    this.masterService.generateHashcodeReport(this.lotteryKey)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }
  
  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  genereteBulkLoi(){

    console.log('Button Call');
    console.log(this.lotteryKey);

    this.masterService.generateBulkLoi(this.lotteryKey)
    .subscribe((data) => {
      if(data.status === 'SUCCESS') {
        this.masterService.successToast(" Job for Bulk LOI Generation Started.");
      }
      else {
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  genereteBulkPOL(){

    console.log('Button Call');
    console.log(this.lotteryKey);

    this.masterService.generateBulkPOL(this.lotteryKey)
    .subscribe((data) => {
      if(data.status === 'SUCCESS') {
        this.masterService.successToast(" Job for Bulk POL Generation Started.");
      }
      else {
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  generateDrawResult(lstName : string){
    console.log("Generete "+lstName+" Draw Result Call");
    console.log(this.lotteryResponseModel.boardKey);
    console.log(this.lotteryKey);

    this.isLoading = true;
    this.masterService.generateDrawResult(this.lotteryResponseModel.boardKey, this.lotteryKey)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = true;
      if(data.status === 'SUCCESS') {
        this.masterService.successToast(lstName+" Draw Result generated Successfully.");
        this.isLoading = false;
      }
      else {
        this.errorToast(data.errorMessage);
        this.isLoading = false;
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
   
  }

  // async saveCategory() {
  //   const response: any = this.boardService.saveCategory(this.catNameEng, this.catNameMar);
  //   console.log(response);
  //   if (!response.error) {
  //     if (response.length > 0) {
  //       this.successToast();
  //     } else {
  //       this.warningToast();
  //     }
  //   } else {
  //     this.errorToast();
  //   }
  // }

  // async successToast() {
  //   await this._snackBar.open("Category details saved successfully.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "success-toast",
  //     duration: 3 * 1000,
  //   });
  // }

  // async warningToast() {
  //   await this._snackBar.open(
  //     "Something went wrong while saving category details, please try again after sometime.",
  //     "Close",
  //     {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "warning-toast",
  //       duration: 3 * 1000,
  //     }
  //   );
  // }

  // async errorToast() {
  //   await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   });
  // }



}
